import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import Header from './Header.vue';
import New from './New.vue';
import Linear from './Linear.vue';
import Radial from './Radial.vue';
import Popular from './Popular.vue';
import Random from './Random.vue';
import Create from './Create.vue';
import Likes from './Likes.vue';
import About from './About.vue';
import Gradient from './Gradient.vue';
import VueClipboard from 'vue-clipboard2';
// import VS2 from 'vue-script2';

Vue.config.devtools = true;
Vue.use(VueRouter);
Vue.use(VueClipboard);
// Vue.use(VS2);

const routes = [
  { path: '/', component: New },
  { path: '/linear', component: Linear },
  { path: '/radial', component: Radial },
  { path: '/popular', component: Popular },
  { path: '/random', component: Random },
  { path: '/create', component: Create },
  { path: '/likes', component: Likes },
  { path: '/about', component: About },
  { path: '/gradient', component: Gradient },
  { path: '/gradient/:id', component: Gradient },
];

const router = new VueRouter({
  scrollBehavior() {
  return { x: 0, y: 0 };
},
routes,
mode: 'history'
});

Vue.component('app-header', Header);

var vm  = new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
window.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js